<template>
  <div>
    <div class="item" @click="handleClickBtn(item)">
      <div class="tag">本产品由{{ item.capitalName }}授权</div>
      <div class="title-container">
        <img v-if="item.capitalLogoList && item.capitalLogoList.length>0"
             :src="item.capitalLogoList[0]" alt/>
        <img v-else :src="item.organLog" alt/>
        <h3 class="item-title">{{ item.productName }}</h3>
      </div>
      <ul>
        <li>
          <h4 class="desc">最高额度</h4>
          <div class="count">
            <div style="font-family: DinAlternateBold;">{{ item.quotaMax / 10000 }} </div>
            <div style="font-size: 16px;color: #2E55E5;position: relative;bottom: 2px;left: 2px;">万元</div></div>
        </li>
        <li>
          <h4 class="desc">最低利率（年化）</h4>
          <div class="count" style="font-family: DinAlternateBold;color: #222222;font-weight: 800;">
            {{ item.loanRate }} <span style="font-size: 18px;position: relative;top: -3px;right: -2px;">%</span>
          </div>
        </li>
      </ul>
      <div class="button-li" :style="{top: (item.productTags && item.productTags.length > 0) ? '69px': '60px'}">
        <van-button class="button" v-show="item.status==7 && item.productNature==0"
                    type="info" size="small" @click.native.stop="handleClickBtn(item)">查看详情
        </van-button>
        <van-button class="button" v-show="item.status==0 && item.productNature==0" type="info"
                    size="small" @click.native.stop="shenheClickBtn">审核中
        </van-button>
        <van-button class="button" v-show="item.status==6 && item.productNature==0" type="info"
                    size="small" :disabled="true">审核未通过
        </van-button>
        <van-button class="button" v-show="item.status==2 && item.productNature==0" type="info"
                    size="small" @click.stop="goRecordDetail(item)">用款
        </van-button>

        <van-button class="button" v-show="item.status==7 && item.productNature==1"
                    type="info" size="small" @click.native.stop="handleClickBtn(item)">马上申请
        </van-button>
        <van-button class="button" v-show="item.status==2 && item.productNature==1" type="info"
                    size="small" @click.native.stop="handleClickBtns(item)">用款
        </van-button>
        <van-button class="button" v-show="item.status==0 && item.productNature==1" type="info"
                    size="small" @click.native.stop="handleClickBtns(item)">办理中
        </van-button>
      </div>
      <div class="bottom-tags">
        <div class="bottom-tag" v-for="(item, index) in item.productTags" :key="'tag'+index">
          {{ item }}
        </div>
      </div>
    </div>
    <!-- <certification-options ref="popup"></certification-options> -->
    <certification-lb ref="popup"></certification-lb>
    <inputPopup ref="inputRef" v-model="bindShow" title="请填写推荐人姓名" leftTitle="跳过" rightTitle="确认"
                :activeIndex=2 @leftChange="productClick(item)" @rightChange="bindUserClick">
    </inputPopup>
  </div>
</template>

<script>
import certificationOptions from "../popup/certificationOptions";
import router from "../../router/index";
import {Toast} from "vant"
import inputPopup from "../inputPopup/index";
import {referencePop} from "../../mixins/market/referencePop"
import {productClick} from "../../mixins/productClick/index"

export default {
  mixins: [referencePop, productClick],
  props: {
    item: {
      type: Object,
    },
  },
  name: "financingItem",
  data() {
    return {};
  },
  components: {
    certificationOptions,
  },
  methods: {
    handleClickBtn(item) {
      this.$emit('detailClick')
      this.userBind(item)
    },
    shenheClickBtn: function () {
      localStorage.setItem("rzjlBack", window.location.href);
      this.$router.replace({path: "/financingRecordsList"});
    },

    handleClickBtns(e) {
      let _this = this;
      let dkId = localStorage.getItem("dkId");
      if (dkId) {
        this.$common.infoSubmit(
          "/app/auth/status",
          {dkId: localStorage.getItem("dkId")},
          (res) => {
            if (res.status == 0) {
              //未认证
              localStorage.setItem("isFirst", "");
              localStorage.setItem("livingToPage", window.location.href);
              _this.$refs.popup.isPageShow = true;
            } else {
              //已认证
              // this.$common.pageEventHandle({eventType: 11, productNo: itemObj.productNo});
              // this.$common.pageEventHandle({eventType: 12, productNo: itemObj.productNo});
              if (e.status == 7) {
                // _this.$common.getProjectUrl(e.productNo, "shenqing");
                return;
              } else {
                let vo = {
                  productNo: e.productNo,
                  dkId: localStorage.getItem("dkId"),
                };
                _this.$common.getProjectUrl(vo, "yongkuan");
              }
              // this.$common.getData("/app/product/applyAgentProductAndUrl", {dkId:localStorage.getItem('dkId'),productNo:itemObj.productNo}, function (res) {
              //   window.location.href=res;
              //   // window.open(res, "_blank");
              // });
            }
          }
        );
      }
    },

    // 本地产品申请成功跳转到记录详情
    goRecordDetail(item) {
      localStorage.setItem("yongkuan", window.location.href);
      this.$router.replace({
        path: "/financingRecordDetail",
        query: {
          capitalName: item.capitalName,
          loanLimit: item.loanLimit,
          productName: item.productName,
          creditStatusDesc: item.creditStatusDesc,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.item {
  position: relative;
  margin: 15px 5px;
  padding: 0 20px 20px 20px;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;

  .tag {
    position: absolute;
    padding: 0 8px 0 18px;
    background: #F9F9F9;
    border-radius: 0 6px 0 4px;
    border: 1px solid #FFFFFF;
    color: #8088A7;
    right: 0;
    top: 0;
    font-size: 10px;
    height: 24px;
    line-height: 24px;
    //transform: scale(0.8);
  }
  .tag::after {
    position: absolute;
    left: 7px;
    top: 2px;
    content: url("/static/image/nav/Shield.svg");
  }

  .title-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 16px;
    padding-top: 24px;
  }

  .title-container img {
    display: inline-block;
    height: 20px;
    width: auto;
  }

  .item-title {
    font-size: 18px;
    //height: 20px;
    //line-height: 20px;
    font-weight: 800;
    color: rgba(24, 25, 24, 1);
    padding-right: 6px;
    margin-left: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .desc {
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    color: #8D95A1;
  }

  .button-li {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    position: absolute;
    right: 15px;

    .button {
      width: 80px;
      height: 30px;
      background: #2E55E5;
      border-radius: 30px;
      font-size: 14px;
      line-height: 30px;
      font-weight: 400;
      color: #ffffff;
      border: none !important;
    }

    .button1 {
      width: 80px;
      height: 30px;
      background: #fff;
      border-radius: 30px;
      font-size: 14px;
      line-height: 30px;
      font-weight: 400;
      color: #2E55E5;
      box-sizing: border-box;
      border: 1px solid #2E55E5 !important;
    }
  }

  ul {
    display: flex;
    width: 76%;

    li {
      flex: 1;
      text-align: left;

      .count {
        font-size: 26px;
        color: #2E55E5;;
        font-weight: bold;
        display: flex;
        align-items: flex-end;
      }

      .percent {
        font-size: 12px;
      }
    }
  }

  .bottom-tags {
    .bottom-tag {
      //border: 1px solid rgba(182, 143, 87, 1);
      background: #FFF6E4;
      height: 22px;
      line-height: 22px;
      border-radius: 2px;
      padding: 0 7px;
      font-size: 12px;
      font-weight: 400;
      color: #AA8344;
      display: inline-block;
      margin-top: 5px;
      margin-right: 4px;
      margin-bottom: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/financingItem/index.vue